import { useApi } from '../services';


export const useGetShareCapitalInfoByLegalPersonId = () => useApi(
    `/v2/economic-group/share-capital-info`,
    'GET',
    {},
    {},
    true
);

export const useGetEconomicGroupSection = (idOperation) => useApi(
    `/v2/economic-group/${idOperation}`,
    'GET',
    {},
    {},
    true
);

export const useGetEconomicGroupSectionHierarchy = (idOperation) => useApi(
    `/v2/economic-group/${idOperation}/hierarchy`,
    'GET',
    {},
    {},
    true
);

export const useGetEconomicGroupHeadStatement = (idOperation) => useApi(
    `/v2/economic-group/${idOperation}/economic-group-statement`,
    'GET',
    {},
    {},
    false
);

export const useSaveEconomicGroup = (idOperation) => useApi(
    `/v2/economic-group/save/${idOperation}`,
    'POST',
    {},
    {},
    true
);

export const useUpdateEconomicGroup = (idOperation) => useApi(
    `/v2/economic-group/update/${idOperation}`,
    'PUT',
    {},
    {},
    true
);

export const useGetBorrowersInformationByLegalPersonIds = () => useApi(
    `/v2/economic-group/borrowers-info`,
    'GET',
    {},
    {},
    true
);

export const useGetBorrowerByIdPerson = () => useApi(
    `/v2/economic-group/borrower-operation`,
    'GET',
    {},
    {},
    true
);

export const useGetBorrowerLimit = (idOperation) => useApi(
    `/v2/economic-group/${idOperation}/borrower-limits-info`,
    'GET',
    {},
    {},
    true
);